module.exports = __webpack_public_path__ + "img/bg.11c16f62.jpg";